// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.quantity-header .el-checkbox {\n    margin-right: 10px !important;\n}\n.quantity-header {\n  display:flex;\n}\n.quantity-input-item {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
